import React, { useEffect, useState } from "react";
import Header from "../Layout/Header";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../../Redux/common/action";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import moment from "moment";
import NewHeader from "../Layout/NewHeader";
import NewSidebar from "../Layout/NewSidebar";
function Withdrawladd() {
  const [box, setbox] = useState("0");
  const [amount, setamount] = useState({});
  const [amountd, setamountd] = useState({});

  const get_profile = useSelector((state) =>
    state?.allapi?.get_profile ? state?.allapi?.get_profile : {}
  );

  const order_list = useSelector((state) =>
    state?.allapi?.get_withdrawal_requset_list
      ? state?.allapi?.get_withdrawal_requset_list
      : {}
  );

  const listdata = order_list?.docs ? order_list?.docs : [];

  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(allapiAction.vendordeshBoradData({}));
    // dispatch(allapiAction.categoryWiseSale({}));
    // dispatch(allapiAction.deshBoradDataUserData());
    dispatch(allapiAction.getprofile());
    dispatch(allapiAction.getWithdrawalListverndor(1));

    return () => {};
  }, []);

  const hendleToChnage = (e) => {
    const { name, value } = e.target;
    setamount((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const hendleToWithdrawal = async () => {
    if (!amount?.address) {
      toast?.error("Please enter address");
      return;
    } else if (!amount?.amount) {
      toast?.error("Please enter amount");
      return;
    } else if (amount?.amount < 10) {
      toast?.error("Please enter amount more than 10");
      return;
    } else {
      const response = await dispatch(allapiAction.Withdrawalsrequset(amount));
      if (response?.success) {
        // dispatch(allapiAction.getprofile());
        // setamount({ amount: "", address: "" });
        setamountd(response?.data);
        console.log("hendleToWithdrawal");
        setbox("1");
      }
    }
  };
  const hendleToWithdrawalverify = async () => {
    if (!amount?.address) {
      toast?.error("Please enter address");
      return;
    } else if (!amount?.amount) {
      toast?.error("Please enter amount");
      return;
    } else if (!amount?.otp) {
      toast?.error("Please enter otp");
      return;
    } else if (amount?.amount < 10) {
      toast?.error("Please enter amount more than 10");
      return;
    } else {
      amount._id = amountd?._id;
      const response = await dispatch(
        allapiAction.WithdrawalsrequsetVerify(amount)
      );
      if (response?.success) {
        dispatch(allapiAction.getprofile());
        setamount({ amount: "", address: "", otp: "" });
        console.log("hendleToWithdrawal");
        setbox("0");
      }
    }
  };
  // Withdrawalsrequset

  return (
    <div>
      <NewHeader />
      <NewSidebar />
      <div class="main" style={{ minHeight: "100vh", paddingTop: "50px" }}>
      <div class="Withralnode mt-5">
        <div class="container">
          <h2>Withdraw</h2>
          {/* <label>Node</label> */}
          {/* <select>
            <option> USDT-BEP-20</option>
          </select> */}

          {box == "0" && <label>Withdraw Address</label>}
          {box == "0" && (
            <input
              type="text"
              placeholder="Please enter address"
              name="address"
              onChange={hendleToChnage}
              value={amount?.address}
            />
          )}

          {box == "0" && <label>Amount</label>}
          {box == "0" && (
            <input
              type="number"
              placeholder="amount"
              name="amount"
              onChange={hendleToChnage}
              value={amount?.amount}
            />
          )}
          {box == "1" && <label>Amount</label>}
          {box == "1" && (
            <input
              type="number"
              placeholder="amount"
              name="amount"
              // onChange={hendleToChnage}
              value={amount?.amount}
            />
          )}
          {box == "1" && <label>Otp</label>}
          {box == "1" && (
            <input
              type="number"
              placeholder="please enter otp"
              name="otp"
              onChange={hendleToChnage}
              value={amount?.otp}
            />
          )}

          {box == "0" && (
            <div class="btn-container">
              {/* <button class="btn btn-cancel">Cancel</button> */}
              <button class="btn btn-submit" onClick={hendleToWithdrawal}>
                Next
              </button>
            </div>
          )}
          {box == "1" && (
            <div class="btn-container">
              {/* <button class="btn btn-cancel">Cancel</button> */}
              <button class="btn btn-submit" onClick={hendleToWithdrawalverify}>
                Submit
              </button>
            </div>
          )}

          <div class="info">
            <p>
              Available Balance:{" "}
              {get_profile?.earningbalance ? get_profile?.earningbalance?.toFixed(4) : 0}
            </p>
              <p>
              Total Withdrawal :{" "}
              {get_profile?.earningbalance ?get_profile?.point - get_profile?.earningbalance : 0}
            </p>
            {/* <p>Minimum Withdrawal: 10 USDT</p>
            <p>Admin Charges: 10%</p> */}
          </div>

          {/* <label>Email verification</label>
        <input type="text" placeholder="Email verification code"/>
        
        <label>Google verification</label>
        <input type="text" placeholder="Google verification code"/>
        
        <div class="btn-container">
            <button class="btn btn-cancel">Cancel</button>
            <button class="btn btn-submit">Submit</button>
        </div> */}

          <div class="row p-3 mb-5">
            <div class="bg-white rounded-4 pb-4">
              <div class="mt-4 d-flex justify-content-between">
                <h6 class="fw-bold">History</h6>
                <Link
                  class="text-decoration-none text-dark"
                  to="/withdrawl-list"
                >
                  <h6 class="fw-bold">
                    All <img src="img/icons8-right-arrow-24.png" alt="" />
                  </h6>
                </Link>
              </div>

              <hr />
              {/* <!-- Horizontal line below the text --> */}

              {listdata &&
                listdata?.map((data, i) => {
                  return (
                    <div class="col d-flex flex-column">
                      <div class="d-flex justify-content-between ">
                        <h6>{data?.reason}</h6>
                        <h6 class="text-danger fw-bold">
                          {data?.requestPayment}
                        </h6>
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <p class="mt-2 text-muted">
                          {moment(data?.createdAt).format(
                            "YYYY-MM-DD HH:mm:ss"
                          )}
                        </p>
                        <button
                          class={
                            data?.status == "reject"
                              ? "btn btn-danger btn-sm"
                              : data?.status == "pending"
                              ? "btn btn-warning btn-sm"
                              : "btn btn-success btn-sm"
                          }
                        >
                          {data?.status}
                        </button>
                      </div>
                    </div>
                  );
                })}
              {/* <div class="col d-flex flex-column">
                <div class="d-flex justify-content-between ">
                  <h6>Trial fund recovery</h6>
                  <h6 class="text-danger fw-bold">-150</h6>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <p class="mt-2 text-muted">2025-02-27 14:13:35</p>
                  <button class="btn btn-success btn-sm">success</button>
                </div>
              </div>

              <div class="col d-flex flex-column ">
                <div class="d-flex justify-content-between ">
                  <h6>Trial fund </h6>
                  <h6 class="text-success fw-bold">+150</h6>
                </div>
                <div class=" d-flex justify-content-between align-items-center">
                  <p class="text-muted mt-2">2025-02-25 14:09:03</p>
                  <button class="btn btn-success btn-sm">success</button>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div style={{ height: "100px" }}></div>
    </div>
    </div>
  );
}

export default Withdrawladd;
